export default __webpack_public_path__ + "static/media/veggiebites@3x.0e79873e.jpg";